<script>
import AttachmentConstants from "@common/constants/AttachmentConstants";
import PDF from "@common/asset/svg/pdf.svg";
import EXCEL from "@common/asset/svg/excel.svg";
import EML from "@common/asset/svg/eml.svg";
import MSG from "@common/asset/svg/msg.svg";
import ZIP from "@common/asset/svg/zip-file-format.svg";
import Compressor from 'compressorjs';
import {cloneDeep} from 'lodash';
const UploadMixin = {
  data() {
    return {
      PDF,
      EXCEL,
      EML,
      MSG,
      ZIP,
      dialogImageUrl: "",
      dialogVisible: false,
      selectedAttachmentIndex: -1,
      rotation: 0,
    };
  },
  computed: {
    selectedImageSrc() {
      return this.selectedAttachment ? this.setIcon(this.selectedAttachment): 
        (this.attachments && this.attachments.length ? this.setIcon(this.attachments[0]): null);
    },
    selectedAttachment() {
      return this.attachments[this.selectedAttachmentIndex] || {};
    },
  },
  methods: {
    isValidFileFormat(fileExt, allowedFileFormats){
      return allowedFileFormats.length ? allowedFileFormats.includes(fileExt) : (AttachmentConstants.images.includes(fileExt) || AttachmentConstants.pdf.includes(fileExt)
        || AttachmentConstants.excel.includes(fileExt) || AttachmentConstants.email.includes(fileExt) || AttachmentConstants.msg.includes(fileExt)
        || AttachmentConstants.zip.includes(fileExt));
    },
    addAttachment(file, fileList, index, allowedFileFormats = []) {
      const isSizeExceed = file.size / 1024 / 1024 < AttachmentConstants.maxMbSize;
      let fileExt = this.findFileExt(file);
      let isFileFormat = this.isValidFileFormat(fileExt, allowedFileFormats);
      if(this.disableBoxOption){
        isFileFormat = AttachmentConstants.images.includes(fileExt);
      }
      if (!isSizeExceed) {   
        this.$errorMessage({ message: this.$getErr('FILE_SIZE_EXCEED')});
        fileList.pop();
      }
      else if (!isFileFormat) {
        this.$errorMessage({ message: this.$getErr('INVALID_FORMAT')});
        fileList.pop();
      } else {
        if (AttachmentConstants.images.includes(fileExt)) {
          this.handleUpload(file,isFileFormat,index,fileList)
        }
        else if (index !== null) {
          this.$emit('addAttachments', file, index);
        } else {
          this.$emit('addAttachments', file);
        }
      }
    },
    handleUpload(file,isFileFormat,index,fileList) {
      let newFile = cloneDeep(file);
      let vm = this;
      new Compressor(file.raw, {
        strict: true,
        checkOrientation: true,
        maxWidth: undefined,
        maxHeight: undefined,
        minWidth: 0,
        minHeight: 0,
        width: undefined,
        height: undefined,
        resize: 'none',
        quality: 0.8,
        mimeType: '',
        convertTypes: 'image/png',
        convertSize: 5000000,
        success: function (result) {
          const formData= new File([result],file.name,{type: "image/jpeg", lastModified: Date.now()});
          newFile.size=formData.size;
          formData.uid=newFile.raw.uid;
          newFile.raw=formData
          newFile.url=window.URL.createObjectURL(formData)
          file=cloneDeep(newFile)
          if (!isFileFormat) {
            vm.$errorMessage({ message: vm.$getErr('INVALID_FORMAT')});
            fileList.pop();
          } else {
            if (index !== null) {
              vm.$emit('addAttachments', file, index);
            } else {
              vm.$emit('addAttachments', file);
            }
          }
        },
      });
    },
    handleExceed() {
      this.$errorMessage({ message: this.$getErr('UPLOAD_LIMIT_EXCEED')});
    },
    previewAttachment(file) {
      this.selectedAttachmentIndex = file.index || 0;
    },
    setIcon(file) {
      let Newfile = file[0] || file
      let fileExt = this.findFileExt(Newfile);
      if (AttachmentConstants.images.includes(fileExt)) {
        let IMAGE = Newfile.url;
        return IMAGE;
      } else if (AttachmentConstants.pdf.includes(fileExt)) {
        return PDF;
      } else if (AttachmentConstants.excel.includes(fileExt)) {
        return EXCEL;
      } else if (AttachmentConstants.email.includes(fileExt)) {
        return EML;
      } else if (AttachmentConstants.msg.includes(fileExt)) {
        return MSG;
      } else if (AttachmentConstants.zip.includes(fileExt)) {
        return ZIP;
      }
    },
    handlePictureCardPreview(file) {
      let Newfile = file[0] || file
      let fileExt = this.findFileExt(Newfile);
      if (AttachmentConstants.images.includes(fileExt)) {
        if (this.showPreviewInParentComponent) {
          const data = { 
            dialogImageUrl: Newfile.url,
            dialogVisible: true,
          };
          this.$emit('preview', data);
        } else {
          this.dialogImageUrl = Newfile.url;
          this.dialogVisible = true;
        }
        // Trigger Image Preview
        this.$refs.thumbImage && this.$refs.thumbImage.$el.children[0].click()
      } else if (
        AttachmentConstants.pdf.includes(fileExt) ||
        AttachmentConstants.excel.includes(fileExt) ||
        AttachmentConstants.email.includes(fileExt) ||
        AttachmentConstants.msg.includes(fileExt) ||
        AttachmentConstants.zip.includes(fileExt)
      ) {
        const link = this.$el.getElementsByClassName("download-file")[0];
        link.href = Newfile.url;
        link.setAttribute("download", Newfile.name);
        link.setAttribute("target", "_blank");
        link.click();
      }
    },
    rotateRight() {
     this.rotation += 90
   },
    rotateLeft() {
     this.rotation -= 90
    },
    handleDownload(file) {
      const link = this.$el.getElementsByClassName("download-file")[0];
      link.href = file.url || file[0].url;
      let fileName=file.name || file[0].name;
      link.setAttribute("download", fileName);
      link.click();
    },
    findFileExt(file) {
      if(file.name) {
        const fileName = file.name;
        return fileName.slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
      } else if(file.url){
        const fileName = file.url;
        const index1 = ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
        let index2 = fileName.indexOf("?");
        index2 = index2 === -1 ? fileName.length : index2;
        return fileName.slice(index1, index2).toLowerCase();
      }
    },
  }
};
export default UploadMixin;
</script>
